import React from "react";
import { Box, Flex, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "./PrimaryButton";

const VideoSlider = () => {
  const navigate = useNavigate();

  return (
    <Box bg="#F7F9FF" w="100%" py={{ base: 10, md: 16 }} px={{ base: 4, md: "30px", lg: "60px", xl: "120px" }}>
      <VStack spacing={12} align="start">
        <Box
          as="h2"
          fontSize={{ base: "2xl", md: "38px" }}
          fontWeight="700"
          lineHeight="1.2"
          color="blue.500"
          textAlign={{ base: "center", xl: "start" }}
          w="100%"
          data-aos="fade-up"
        >
          Ve cómo funciona con una operación real
        </Box>

        <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} spacing="48px" w="100%" alignItems="flex-end" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
          {/* Video */}
          <Box>
            <Box
              w="100%"
              aspectRatio="16 / 9"
              borderRadius="3xl"
              overflow="hidden"
              boxShadow="0px 4px 24px rgba(0,0,0,0.12)"
              bg="black"
            >
              <iframe
                src="https://www.youtube-nocookie.com/embed/OltQufXN62Q"
                title="Ve cómo funciona Saga Fiscal"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
            <Text textAlign={'center'} mt={2} color={'black.400'}>
              En menos de 3 minutos: conoce el funcionamiento de SAGA
            </Text>
          </Box>

          {/* Texto y CTA */}
          <VStack align={{ base: "center", xl: "start" }} spacing={12} mb={7} w="100%">
            <Box>
              <Text
                fontSize={{ base: "16px", md: "18px", lg: "20px", xl: "24px" }}
                fontWeight="400"
                textAlign={{ base: "center", xl: "start" }}
              >
                ¿Prefieres verlo con tus propios datos?
              </Text>
              <Text
                fontSize={{ base: "16px", md: "18px", lg: "20px", xl: "24px" }}
                fontWeight="400"
                textAlign={{ base: "center", xl: "start" }}
              >
                Activa tu prueba gratuita de 2 semanas, sin tarjeta de crédito.
              </Text>
            </Box>

            <PrimaryButton fontSize={{ base: "16px", md: "18px", lg: "20px" }} bg="blue.500" color="white" _hover={{ bg: "blue.600" }} width={'auto'} onClick={() => navigate("/contactos")}>
              Pruébalo gratis 2 semanas
            </PrimaryButton>
          </VStack>
        </SimpleGrid>
      </VStack>
    </Box>
  );
};

export default VideoSlider;
